var map = {
	"./": [
		156
	],
	"./en": [
		530,
		0
	],
	"./en.ts": [
		530,
		0
	],
	"./fr": [
		197
	],
	"./fr.ts": [
		197
	],
	"./index": [
		156
	],
	"./index.ts": [
		156
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 729;
module.exports = webpackAsyncContext;